<div
    class="relative cursor-pointer px-sm pl-lg py-xs h-input font-roboto text-input-text text-input flex items-center bg-dropdown-item-background-default hover:bg-dropdown-item-background-hover hover:text-dropdown-item-text-hover"
    [ngClass]="{
        'bg-dropdown-item-background-hover text-dropdown-item-text-hover': isFocused
    }"
    (click)="itemClicked.emit(value)">
    @if (isSelected) {
        <span class="absolute left-xs" porIcon icon="check" [width]="16" [height]="16"></span>
    }
    <span>{{ label }}</span>
</div>
